import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { customiseAutomation } from "../../../userOnboardingConstants";
import { useContext, useEffect, useState } from "react";
import { userOnboardingContext } from "../../../states/context/userOnboardingContext";
import { CloseCircle } from "../../../assets/images/closeCircle";

const StyledDialog = styled(Dialog)({
  '& .MuiDialog-paper': {
    borderRadius: 20,
    padding: "32px",
    overflowY: "initial",
    maxWidth: "808px",
  },
  '& .MuiBackdrop-root': {
    backdropFilter: "blur(2px)",
    backgroundColor: "rgba(23, 23, 23, 0.40)",
  },
});

const StyledDialogTitle = styled(DialogTitle)({
  color: "#171717",
  fontWeight: "600",
  fontSize: "24px",
  fontFamily: "Figtree",
  margin: 0,
  padding: 0,
});

const CloseButton = styled(IconButton)({
  position: "absolute",
  top: -54,
  left: "50%",
  transform: "translateX(-50%)",
});

const StyledDialogContent = styled(DialogContent)({
  padding: "0",
  marginBottom: "48px",
  marginTop: '32px',
  display: "flex",
  justifyContent: "space-between",
  gap: "25px",
});

const LeftContainer = styled(Box)({
  width: "50%",
});

const LeftPara = styled(Typography)({
  fontFamily: "Figtree",
  fontWeight: 400,
  color: "#747474",
  marginBottom: "24px",
});

const RightContainer = styled(Box)({
  display: "flex",
  width: "50%",
  flexDirection: "column",
});

const StyledDialogActions = styled(DialogActions)({
  display: "flex",
  gap: "25px",
  justifyContent: "space-between",
  padding: 0,
});

const StyledTextArea = styled('textarea')({
  resize: "none",
  borderRadius: "8px",
  width: "88%",
  height: "100%",
  padding: "12px 24px 12px 16px",
  outline: "none",
  backgroundColor: "#F7F7F7",
  marginTop: "20px",
  fontFamily: "Figtree",
  border: "none",
});

const ParameterList = styled('li')({
  marginBottom: "16px",
  fontFamily: "Figtree",
  color: "#747474",
  '&::marker': {
    color: "#6933FF",
  },
});

const SubmitButton = styled(Button)({
  backgroundColor: "#6933FF",
  color: "white",
  textTransform: "none",
  width: "50%",
  height: "48px",
  fontWeight: "600",
  fontFamily: "Figtree",
  marginLeft: "0 !important",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: "#6933FF",
    color: "white",
    boxShadow: "none",
  },
});

const CancelButton = styled(Button)({
  backgroundColor: "#F0EBFF",
  color: "#6933FF",
  textTransform: "none",
  width: "50%",
  boxShadow: "none",
  height: "48px",
  fontWeight: "600",
  fontFamily: "Figtree",
  "&:hover": {
    backgroundColor: "#F0EBFF",
    color: "#6933FF",
    boxShadow: "none",
  },
});

const CommonText = styled(Typography)({
  color: "#171717",
  fontWeight: 600,
  fontFamily: "Figtree",
});

export const DialogComponent = ({ open, close, title }) => {
  const { user, setUser } = useContext(userOnboardingContext);
  const { automationCardDetail } = user;

  const [input, setInput] = useState("");

  const handleClose = (e, r) => {
    e.stopPropagation();
    close(false);
  };

  const handleUserCustomizeSuggestion = (e) => {
    const typedValue = e.target.value;
    const matchingItem = automationCardDetail.find(
      (item) => item.title === title
    );
    setInput(e.target.value);
  };

  const handleSubmit = (e) => {
    e.stopPropagation();
    const matchingItem = automationCardDetail?.filter(
      (item) => item.title !== title
    );
    setUser({
      ...user,
      automationCardDetail: [...matchingItem, { title: title, text: input }],
    });
    close(false);
  };

  useEffect(() => {
    const matchingItem = automationCardDetail?.find(
      (item) => item.title === title
    );
    setInput(matchingItem?.text);
  }, []);

  return (
    <StyledDialog
      open={open}
      onClose={handleClose}
      disableRestoreFocus
    >
      <>
        <StyledDialogTitle disableTypography>
          {customiseAutomation.title}
        </StyledDialogTitle>
        <StyledDialogContent>
          <LeftContainer>
            <LeftPara>
              Our team will reach out to you once we receive your automation
              customization request.
            </LeftPara>
            <Box>
              <CommonText>
                Customisable parameters
              </CommonText>
              <ul style={{ paddingLeft: "20px", marginTop: "20px" }}>
                {customiseAutomation?.customParameters?.map((item, index) => {
                  return (
                    <ParameterList key={index}>
                      {item}
                    </ParameterList>
                  );
                })}
              </ul>
            </Box>
          </LeftContainer>
          <RightContainer>
            <CommonText>
              Describe how would you like for us to customize this automation
              for you
            </CommonText>
            <StyledTextArea
              placeholder="Type here..."
              onChange={handleUserCustomizeSuggestion}
              value={input}
            />
          </RightContainer>
        </StyledDialogContent>
        <StyledDialogActions>
          <CancelButton
            variant="contained"
            onClick={handleClose}
          >
            Cancel
          </CancelButton>
          <SubmitButton
            variant="contained"
            onClick={handleSubmit}
          >
            Submit
          </SubmitButton>
        </StyledDialogActions>
      </>
      <CloseButton onClick={handleClose}>
        <CloseCircle onClick={handleClose} />
      </CloseButton>
    </StyledDialog>
  );
};
